export const API_URL = "http://localhost:5000"


export const generateTransactionId = () => {
    return 'TransId_' + new Date().getTime() + '_' + Math.floor(Math.random() * 1000000);};

    export const TestBaseURL = "https://pgsandbox.xpresspayments.com:8090"
    
    export const LiveBaseURL = "https://myxpresspay.com:6004"